<!-- this element caches the icon sprite for use in SVG elements -->
<div style="display: none;" [innerHTML]="this.content | async"></div>
<!--example usage:-->
  <!--<svg>-->
    <!--<use xlink:href="#My-Icon"></use>-->
  <!--</svg>-->
